import { render, staticRenderFns } from "./AssessorDetalheModal.vue?vue&type=template&id=8d8b66b2&scoped=true&"
import script from "./AssessorDetalheModal.vue?vue&type=script&lang=js&"
export * from "./AssessorDetalheModal.vue?vue&type=script&lang=js&"
import style0 from "./AssessorDetalheModal.vue?vue&type=style&index=0&id=8d8b66b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8b66b2",
  null
  
)

export default component.exports